<div class="fields-area notifications-wrapper">
  <div class="settings-header-row">
    <span class="title">Notifications</span>
  </div>
  <pdq-tabs-group class="tabs" (onChange)="switchTab($event)" variant="underline">
    @for (tab of tabsData; track tab) {
      <pdq-tab [value]="tab.value" [disabled]="tab.value === 'slack'" [active]="tab.active" [label]="tab.label">
      </pdq-tab>
    }
  </pdq-tabs-group>
  <img
    class="sound-icon"
    matTooltip="Test sound"
    matTooltipClass="pdq-mat-tooltip"
    src="assets/icons/sound-on.svg"
    (click)="playSound()" />
  <article class="content">
    @if (isActiveTab('internal')) {
      <app-notifications-internal></app-notifications-internal>
    }
  </article>
</div>
